import { API_ENDPOINT_DEPLOYED, LOGIN_ENDPOINT } from "./constants";
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: API_ENDPOINT_DEPLOYED,
  withCredentials: true,
});
let interceptorsSet = false;
export const setUpInterceptors = () => {
  if (interceptorsSet) return;
  interceptorsSet = true;

  axiosInstance.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

const getErrorMessage = (error) => {
  if (error.config && error.config.url && error.config.url.includes("verify_session")) {
    return null;
  }
  if (error.response) {
    if (error.response.status === 422) {
      return 'Invalid request';
    }
    return error.response.data?.detail || 'An error occurred';
  }
  return error.message || 'An error occurred';
};

const sendRequest = async (url, data = null, method = 'GET', isLoginRequest = false, useBaseUrl = true) => {
  try {
    const config = {
      method,
      url,
      isLoginRequest: isLoginRequest,
    };

    if (!useBaseUrl) {
      config.baseURL = '';
    }

    if (data) {
      config.data = data;
    }

    const response = await axiosInstance(config);

    return response.data;
  } catch (error) {
    if (error.config && error.config.url && error.config.url.includes("verify_session")) {
      return null;
    }

    if (error.response && error.response.status === 401) {
      window.location.href = LOGIN_ENDPOINT + "?redirect_url=" + window.location.href;
    }
    const enhancedError = new Error(getErrorMessage(error));

    enhancedError.response = error.response || null;
    enhancedError.request = error.request || null;
    enhancedError.config = error.config || null;

    throw enhancedError;
  }
};

export default sendRequest;